import React from 'react';
import {
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Popover,
  Button,
} from '@mui/material';
import {
  Comment as CommentIcon,
  Cake as CakeIcon,
  CheckCircle as CheckCircleIcon,
  Event as EventIcon,
} from '@mui/icons-material';

const notifications = [
  {
    id: 1,
    icon: <CakeIcon color="success" />,
    message: "It's Cristina danny's birthday today.",
    time: '2 min ago',
    timestamp: '3:00 AM',
  },
  {
    id: 2,
    icon: <CommentIcon color="primary" />,
    message: 'Aida Burg commented your post.',
    time: '5 August',
    timestamp: '6:00 AM',
  },
  {
    id: 3,
    icon: <CheckCircleIcon color="error" />,
    message: 'Your Profile is Complete 60%',
    time: '7 hours ago',
    timestamp: '2:45 PM',
  },
  {
    id: 4,
    icon: <EventIcon color="info" />,
    message: 'Cristina Danny invited to join Meeting.',
    time: 'Daily scrum meeting time',
    timestamp: '9:10 PM',
  },
];

interface NotificationPopoverProps {
  anchorEl: null | HTMLElement;
  onClose: () => void;
}

const NotificationPopover: React.FC<NotificationPopoverProps> = ({ anchorEl, onClose }) => (
  <Popover
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    PaperProps={{
      elevation: 3,
      sx: { mt: 1.5, width: 360, maxHeight: 500 },
    }}
  >
    <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        Notification
      </Typography>
      <CheckCircleIcon color="success" fontSize="small" />
    </Box>
    <Divider />
    <List sx={{ p: 0 }}>
      {notifications.map((notification, index) => (
        <React.Fragment key={notification.id}>
          <ListItem
            sx={{
              py: 1.5,
              px: 2,
              '&:hover': { bgcolor: 'action.hover' },
              cursor: 'pointer',
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Avatar sx={{ width: 32, height: 32, bgcolor: 'background.paper' }}>
                {notification.icon}
              </Avatar>
            </ListItemIcon>
            <ListItemText
              primary={notification.message}
              secondary={notification.time}
              primaryTypographyProps={{ variant: 'body2', sx: { fontWeight: 500 } }}
              secondaryTypographyProps={{ variant: 'caption', color: 'text.secondary' }}
            />
            <Typography variant="caption" color="text.secondary" sx={{ ml: 2 }}>
              {notification.timestamp}
            </Typography>
          </ListItem>
          {index < notifications.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </List>
    <Divider />
    <Box sx={{ p: 2, textAlign: 'center' }}>
      <Button size="small" onClick={onClose} sx={{ textTransform: 'none' }}>
        View All
      </Button>
    </Box>
  </Popover>
);

export default NotificationPopover;
